import { render, staticRenderFns } from "./index-cell.vue?vue&type=template&id=671a9327&scoped=true&"
import script from "./index-cell.vue?vue&type=script&lang=js&"
export * from "./index-cell.vue?vue&type=script&lang=js&"
import style0 from "./index-cell.vue?vue&type=style&index=0&id=671a9327&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a9327",
  null
  
)

export default component.exports